import { toast } from "sonner";
import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import {
  CreateExamPayload,
  createQuestion,
  Exam,
  ExamDetails,
  ExamFilters,
} from "../types/ExamType";
import { PaginatedResponse } from "../types/paginationType";

const examsApis = {
  //post
  createExam: async (
    branchId: string,
    payload: CreateExamPayload
  ): Promise<ApiResponse<any> | undefined> => {
    try {
      const { data } = await customFetch.post(
        `/api/v1/exam/create-exam/${branchId}`,
        payload
      );
      toast.success("Exam created successfully");
      return data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Something went wrong");
      return undefined;
    }
  },

  // Edit
  updateExam: async (examId: string, payload: CreateExamPayload) => {
    try {
      const response = await customFetch.put(
        `/api/v1/exam/update-exam/${examId}`,
        payload
      );

      toast.success(response.data.data || "Exam updated successfully");
      return response.data.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update Exam");
      throw err;
    }
  },

  // fetch all
  fetchExams(
    params: ExamFilters
  ): Promise<{ data: ApiResponse<PaginatedResponse<Exam>> }> {
    return customFetch.get("/api/v1/exam/filter-exams", { params });
  },

  // section
  addExamSection: async (
    examId: number,
    payload: { sectionName: string }
  ): Promise<ApiResponse<any> | undefined> => {
    try {
      const { data } = await customFetch.post(
        `/api/v1/exam/add-section/${examId}`,
        payload
      );
      toast.success("Section added successfully");
      return data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to add section");
      return undefined;
    }
  },

  //fetch by id
  getExamsBySeqId: async (
    seqId: string
  ): Promise<ApiResponse<ExamDetails> | undefined> => {
    try {
      const res = await customFetch.get(`/api/v1/exam/get-exam/${seqId}`);
      return res.data as ApiResponse<ExamDetails>;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load form");
      return undefined;
    }
  },

  //update section
  updateSection: async (sectionId: string, sectionName: string) => {
    try {
      const response = await customFetch.put(
        `/api/v1/exam/update-section/${sectionId}`,
        { sectionName }
      );
      toast.success("Section Updated successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update section");
      throw err;
    }
  },

  deleteSection: async (sectionId: string) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/exam/remove-section/${sectionId}`
      );
      toast.success("Section deleted successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete section");
      throw err;
    }
  },

  // add Questions
  addQuestion: async (sectionId: number, payload: createQuestion) => {
    try {
      const res = await customFetch.post(
        `/api/v1/exam/add-question/${sectionId}`,
        payload
      );
      toast.success(res.data?.data || "Question added successfully");
      return res.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to add question");
      throw err;
    }
  },

  // update question
  updateQuestion: async (questionId: number, payload: createQuestion) => {
    try {
      const res = await customFetch.put(
        `/api/v1/exam/update-question/${questionId}`,
        payload
      );
      toast.success(res.data?.data || "Question updated successfully");
      return res.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update question");
      throw err;
    }
  },

  // delete questions
  deleteQuestions: async (questionId: string) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/exam/remove-question/${questionId}`
      );
      toast.success("Question deleted successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete question");
      throw err;
    }
  },

  // delete questions
  deleteExamForm: async (examId: string) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/exam/${examId}`
      );
      toast.success("Exam deleted successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete Exam");
      throw err;
    }
  },
};

export default examsApis;
